export const ACTIVE_CART_PAGE_SEARCH_QUERIES_STORAGE_KEY =
  "ACTIVE_CART_PAGE_SEARCH_QUERIES_STORAGE_KEY";
export const SAVED_CART_PAGE_SEARCH_QUERIES_STORAGE_KEY =
  "SAVED_CART_PAGE_SEARCH_QUERIES_STORAGE_KEY";
